module.exports = __webpack_public_path__ + "img/Ereignis.c0bd5dda.svg";